import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { BsTrash } from "react-icons/bs";
import EmojiShort from "../../../../../components/emoji-picker/emoji-short.json";
import UserGroups from "../../../../../components/pickers/user-groups/UserGroups";
import WorkflowPicker from "../../../../../components/workflow/WorkflowPicker";
import { ChatSettingsEmojiActionInput } from "../../../../../__generated__/api";

const EVERYONE_GROUP = "urn:fq:user-group:everyone";
export default function EmojiActions({ actions, onChange }: {
    actions: ChatSettingsEmojiActionInput[],
    onChange: (actions: ChatSettingsEmojiActionInput[]) => void;
}) {
    const [emoji, setEmoji] = useState<string>();
    const [description, setDescription] = useState<string>();
    const [groups, setGroups] = useState<string[]>();

    const save = (index: number, value: Partial<ChatSettingsEmojiActionInput>) => {
        const copy = [...actions];
        copy[index] ??= Object.create(null);
        copy[index] = { ...copy[index], ...value };
        onChange(copy);
    };

    const allActions: ChatSettingsEmojiActionInput[] = [...(actions ?? []), Object.create(null)];
    return (
        <div className="border p-3 rounded mb-4 bg-white">
            <h5 className="mb-3 text-light">
                Emoji Automations
            </h5>

            <p className="text-light">
                Emoji actions let you execute custom automation whenever an emoji is added to a message in Slack
                that has the Foqal Agent bot already installed in that Slack channel.
                For example, lets say you have a channel called #emergency. By installing the Agent bot in that channel,
                and configuring an automation for the fire emoji below, you can allow users to fire a action
                such as a Pager Duty alert whenever a user adds the fire emoji to a Slack message.
            </p>

            <div className="list-group">
                {allActions.map((action, index) => {
                    const hasEveryoneGroup = (groups ?? []).includes(EVERYONE_GROUP);

                    return (
                        <div
                            key={action.emoji}
                            className={"list-group-item list-group-item-action "
                            + "d-flex align-items-center d-flex justify-content-between"}
                        >
                            {action.emoji && (
                                <div className="flex-grow-1">

                                    <h5 className="mb-0 w-25">
                                        {EmojiShort[`:${action.emoji}:` as keyof typeof EmojiShort] as string
                                            ?? `:${action.emoji}:`}
                                    </h5>

                                    <small className="d-block mt-1">
                                        {action.description}
                                    </small>
                                </div>
                            )}

                            <div className="d-flex flex-grow-0 align-items-end">
                                <WorkflowPicker
                                    buttonClassName="text-light px-0"
                                    title={action.emoji ? `Emoji Automation: ${action.emoji}` : "New Emoji Automation"}
                                    buttonText={action.emoji ? "Edit Emoji Automation" : "New Emoji Automation"}
                                    workflowId={action.workflowId}
                                    shouldAddExecutor
                                    shouldAddEmojiContext
                                    onWorkflowSaved={workflowId => {
                                        save(index, {
                                            workflowId,
                                            emoji,
                                            description,
                                            allowedExecuteGroups: groups,
                                        });
                                    }}
                                    onOpen={() => {
                                        setEmoji(action.emoji ?? "");
                                        setDescription(action.description ?? "");
                                        setGroups(action.allowedExecuteGroups ?? [EVERYONE_GROUP]);
                                    }}
                                >
                                    <Form.Group className="mb-4 d-flex">
                                        <Form.Label className="fw-bolder col-2">
                                            Emoji
                                        </Form.Label>
                                        <Form.Control
                                            className="col"
                                            placeholder="simple_smile"
                                            required
                                            value={emoji}
                                            onChange={target => {
                                                setEmoji(target.target.value);
                                            }}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-4 d-flex">
                                        <Form.Label className="fw-bolder col-2">
                                            Description
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            className="col"
                                            placeholder="This workflow represents"
                                            value={description}
                                            onChange={target => {
                                                setDescription(target.target.value);
                                            }}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-4 d-flex">
                                        <Form.Label className="fw-bolder col-2">
                                            Groups able to execute
                                        </Form.Label>
                                        <div className="d-flex align-items-center col">
                                            <Form.Check
                                                type="switch"
                                                name={`picker-${index}`}
                                                label={hasEveryoneGroup ? "Everyone" : "Specific Groups"}
                                                className="ms-2 col-2"
                                                checked={hasEveryoneGroup}
                                                onChange={evt => {
                                                    if (evt.target.checked) {
                                                        setGroups([EVERYONE_GROUP]);
                                                    } else {
                                                        setGroups([]);
                                                    }
                                                }}
                                            />

                                            {!hasEveryoneGroup && (
                                                <UserGroups
                                                    isMulti
                                                    className="w-100"
                                                    onSelected={groupIds => {
                                                        setGroups(groupIds);
                                                    }}
                                                    value={groups}
                                                />
                                            )}
                                        </div>
                                    </Form.Group>
                                </WorkflowPicker>
                                {action.emoji && (
                                    <button
                                        type="button"
                                        className="btn btn-none"
                                        onClick={() => {
                                            const copy = [...actions];
                                            copy.splice(index, 1);
                                            onChange(copy);
                                        }}
                                    >
                                        <BsTrash className="text-light" />
                                    </button>
                                )}

                            </div>

                        </div>

                    );
                })}

            </div>
            {/* <button
                type="button"
                className="btn btn-secondary btn-sm my-3"
                onClick={() => onChange([...actions, Object.create(null)])}
            >
                <AiOutlinePlus />
                {" "}
                Add Emoji Action
            </button> */}

        </div>
    );
}
